import { Box, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import Layout from "../../../components/Layout";
import { crm } from "../components/crmTheme";
import FilesTab from "./FilesTab";
import QuotesTab from "./QuotesTab";

/** CRM › Estimativas: orçamentos salvos pelo Simulador + arquivos de estimativas da pasta compartilhada. */
const Estimates = () => (
  <Box height="100%">
    <Layout>
      <Flex alignItems="center" flexDirection="column" backgroundColor="var(--main-bg-color)">
        <Flex width="90%" mt="48px" mb="24px" align="center" gap="12px">
          <Box w="4px" h="34px" bg={crm.brand} borderRadius="full" />
          <Box>
            <Text fontSize="28px" fontWeight="700" color={crm.text} lineHeight="1.1">
              Estimativas
            </Text>
            <Text color={crm.textMuted} fontSize="sm" mt="2px">
              Orçamentos do Simulador e arquivos de estimativas do comercial.
            </Text>
          </Box>
        </Flex>

        <Box width="90%">
          <Tabs variant="line" colorScheme="blue" isLazy>
            <TabList mb="16px">
              <Tab fontWeight="600">Orçamentos</Tab>
              <Tab fontWeight="600">Arquivos</Tab>
            </TabList>
            <TabPanels>
              <TabPanel p="0">
                <QuotesTab />
              </TabPanel>
              <TabPanel p="0">
                <FilesTab />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Flex>
    </Layout>
  </Box>
);

export default Estimates;
